<div class="container">
    <h2>{{text.PAGE_NOT_FOUND}}</h2>
    <h4 [innerHtml]="text.BACK_TO_HOME"></h4>
</div>